import React, { useState,useEffect } from "react";
import { BtnAlmacenar} from "componentes/templates/btn_crud";
import {
  DefaultSelect,
 } from "componentes/templates/input";
 import { Cargando } from "componentes/templates/cargando";
 import { GET } from 'helpers/request';
 import { POST } from 'helpers/request'
 import LanguageHelper from 'helpers/language_helper'

export default function FormSubthematics({ ind_int_id }) {

  


  
  /* Arreglo con las variables para colocar los datos en el formulario */
  const variables = [
    "sou_int_id",
    "sin_sts_register",
    "ind_int_id",
  
  ];

  const [cargando, setCargando] = useState(true);

  const [listado, setListado] = useState(false);
  const [actualizar] = useState(false);

  
  const gestionarCambio = (event) => {
    if (event.target.type === "radio") {
      localStorage.setItem(event.target.name, event.target.value);
    } else {
      localStorage.setItem(event.target.id, event.target.value);
    }
  };


  const Verificar = (result) => {
    let resultado = result;
    if (resultado.status === 201) {
      alert(resultado.messages);
      // limpiar el storage
      variables.forEach(function (valor) {
        localStorage.removeItem(valor);
      });
      window.location.reload();
    } else {
      // regresó error (normalmente 400), no pasó la validación
      variables.forEach(function (valor) {
        // es el mensaje de error q devuelve la validacion del codeigniter
        if (document.getElementById(valor + "_msj") !== null) {
          let mensaje = resultado[valor];
          document.getElementById(valor + "_msj").classList.remove("is-hidden");
          document.getElementById(valor + "_msj").textContent = mensaje;
        }

      });
    }
  };

  
  const gAlmacenar = async (e) => {
    e.preventDefault();
    localStorage.setItem("ind_int_id", ind_int_id);
    try {
      const data = await POST(variables, "indicators/sourcesIndicators");
      // console.log(res);
      Verificar(data);
      
    } catch (error) {
      console.log("error", error)
    }
    
  };

  const prepararListado = (result) => {
    var resultados = result;

    var indicators = resultados.datos;
      
    const listaItems = ()=> {
      return (

        <DefaultSelect
        label={LanguageHelper.getLanguageString('SourcesIndicators.source')}
        inputName="sou_int_id"
        onChange={gestionarCambio}
        options={indicators}
      />

       
      );
    };
    setCargando(false);
    setListado(listaItems);
  };

useEffect(() => {
  
  let urlU = `indicators/optionSources`;
  const fetcher = async () => {
    const list = await GET(urlU);
    list.error ? console.log("error useEffect ", list.error) : prepararListado(list);

  };
  fetcher();

  
   

  variables.forEach(function (valor) {
    localStorage.removeItem(valor);
  });
    
  

  return () => {
    setCargando(true);
  };
  // eslint-disable-next-line
}, [actualizar])

if (cargando) return <Cargando />;
  else
  return (
    <div className="container is-fluid">
      <div className="columns">
        <div className="column is-5 is-offset-1">
          

          <form autoComplete="nope">
          <div className="field">
          {listado}
          
            </div>           
            
           
              <BtnAlmacenar gAlmacenar={gAlmacenar}>{LanguageHelper.getLanguageString('SourcesIndicators.save')}</BtnAlmacenar>
            
          </form>
        </div>
       

      </div>
      
    </div>
  );
}
